/**
 * Image and text Vue Component
 * ------------------------------------------------------------------------------
 * Main template in sections/index__image-and-text.liquid
 */

import VueAccordion from './vue-accordion.vue'
import VueCollapsible from './vue-collapsible.vue'

export default {
  name: 'ImageText',
  components: {
    VueAccordion,
    VueCollapsible
  }
}
